import React from "react"
import {
	CreateButton,
	Datagrid,
	DateField,
	DeleteWithConfirmButton,
	EditButton,
	List,
	TextField,
	TopToolbar
} from "react-admin"

import sx from "utils/sx"

const Actions = () => <TopToolbar>
	<CreateButton label="misc.create" />
</TopToolbar>

const JobsList = () => {
	return <List
		actions={<Actions />}
		title="resources.jobs.title"
	>
		<Datagrid
			rowClick="edit"
			bulkActionButtons={false}
			sx={sx.datagridColumns}
		>
			<TextField
				headerClassName="column-fullName"
				cellClassName="column-fullName"
				source="name"
				label="resources.jobs.fields.name"
			/>
			<DateField
				source="createdAt"
				label="resources.jobs.fields.created_at"
			/>
			<DateField
				source="updatedAt"
				label="resources.jobs.fields.updated_at"
			/>
			<EditButton
				label=""
				size="large"
				sx={sx.datagridButton}
			/>
			<DeleteWithConfirmButton
				label=""
				size="large"
				confirmTitle="misc.delete"
				confirmContent="misc.deleteContent"
				sx={sx.datagridButton}
			/>
		</Datagrid>
	</List>
}

export default JobsList
